import { RootState } from "@/app/stores"
import { IAuthResponse, login as loginRequest } from "@/shared/api/auth"
import { IRegisterOrganizationRequest, IRegisterOrganizationResponse, registerOrganization as registerOrganizationRequest } from "@/shared/api/onboarding"
import { ErrorType } from "@/shared/types"
import { createAsyncThunk } from "@reduxjs/toolkit"
import { AxiosError } from "axios"

interface IFetchLogin {
    password: string,
    login: string
}

export const fetchLogin = createAsyncThunk<
    IAuthResponse,
    IFetchLogin,
    { state: RootState }
>('auth/fetchLogin', async(req, thunkAPI) => {
    try {
        const { password, login } = req
        const data = await loginRequest(login, password)
        localStorage.setItem('access_token', data.data.access_token)
        localStorage.setItem('refresh_token', data.data.refresh_token)
        return data.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})

export const logout = createAsyncThunk<
    void,
    void,
    { state: RootState }
>('auth/logout', async(_, thunkAPI) => {
    try {
        localStorage.removeItem('access_token')
        localStorage.removeItem('refresh_token')
        window.location.href = '/auth'
        return
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})

export const fetchRegisterOrganization = createAsyncThunk<
    IRegisterOrganizationResponse,
    IRegisterOrganizationRequest,
    { state: RootState }
>('auth/fetchRegisterOrganization', async(req, thunkAPI) => {
    try {
        const data = await registerOrganizationRequest(req)
        localStorage.setItem('access_token', data.data.tokens.access_token)
        localStorage.setItem('refresh_token', data.data.tokens.refresh_token)
        return data.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})